import {JSX, memo} from "react";

import SmartImage from "@/shared/ui/smart-image";

import type {TestimonialItem} from "@/sections";

import {Typography} from "@/shared/ui/data-display/typography";

interface SliderTestimonialsSlideProps {
    testimonial: TestimonialItem;
    index: number;
    isActive: boolean;
    onSlideClick: (index: number) => void;
}

export const SliderTestimonialsSlide = memo(function SliderTestimonialsSlide({
    testimonial,
    index,
    isActive,
    onSlideClick,
}: SliderTestimonialsSlideProps): JSX.Element {
    const {review} = testimonial;

    return (
        <div
            className={`keen-slider__slide slider-testimonials__slide ${isActive ? "slider-testimonials__slide--active" : ""}`}
            onClick={() => onSlideClick(index)}
        >
            <div className="slider-testimonials__card">
                <div className="slider-testimonials__quote">
                    <Typography
                        as="p"
                        size={{desktop: 16, mobile: 14}}
                        weight={400}
                        color="black"
                        className="slider-testimonials__quote-text"
                        innerHTML={review.text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")}
                    />
                </div>
                <div className="slider-testimonials__author">
                    {review.image && (
                        <div className="slider-testimonials__author-image">
                            <SmartImage
                                src={review.image.src}
                                alt={review.image.alt || review.author}
                                width={60}
                                height={60}
                                className="slider-testimonials__author-image-img"
                            />
                        </div>
                    )}
                    <div className="slider-testimonials__author-info">
                        <Typography as="div" size={{desktop: 16, mobile: 14}} weight={600} className="slider-testimonials__author-name">
                            {review.author}
                        </Typography>
                        <Typography
                            as="div"
                            size={{desktop: 14, mobile: 12}}
                            weight={400}
                            color="paragraph"
                            className="slider-testimonials__author-position"
                        >
                            {review.position}
                        </Typography>
                    </div>
                </div>
            </div>
        </div>
    );
});
